export default __webpack_public_path__ + "static/media/tip-icon.39bf32ff.svg";